export interface ICalendarDate {
  date: Date
  disabled: boolean
  selected: boolean
}
